import axios from "axios";

const isDebug = process.env.REACT_APP_ENV === "DEBUG";
const isLocal = process.env.REACT_APP_ENV === "LOCAL";

const BASE_API_URL = isLocal
  ? "http://localhost:8080/api/eight-char"
  : isDebug
  ? "https://dev.fortune.leinotek.com/api/eight-char"
  : "https://fortune.leinotek.com/api/eight-char";

class AnalysisService {
  analyticsUserEightChar(year, month, day, hour, minute, gender, calendarType) {
    return axios.post(BASE_API_URL + "/analytics", {
      year,
      month,
      day,
      hour,
      minute,
      gender,
      calendarType,
    });
  }

  getUserEightChar() {
    return JSON.parse(localStorage.getItem("user-eightchar"));
  }
}

const analysisService = new AnalysisService();
export default analysisService;
